/* eslint-disable react/no-danger */

import { useEffect, useState } from 'react';
// @mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Image from 'src/components/image';
import { IconButton, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { format } from "date-fns";


// ----------------------------------------------------------------------

type Props = {
  certificateData: any;
  status: (value:boolean) => void;
  active: boolean;
};

export default function DetailsDialog({certificateData, status, active}: Props) {
  
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    status(false)
  };

  const rankTexts: { [key: number]: string } = {
    1: "Đạt tốt nghiệp",
    2: "Khá",
    3: "Giỏi",
    4: "Xuất sắc"
  };
  
  const dfm = (inputDateString: any) => {
    const date = new Date(inputDateString);
    return format(date, 'dd/MM/yyyy');
  }

  const capitalize = (text:string) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()

  return (
    <Dialog
      open={active}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >      
    {certificateData && (
      <DialogContent sx={{p: { xs: 2, md: 0 }, minHeight:{ xs: '550px', md: '100%' }, position: 'relative',}}>
        <Image alt='ttu mau bang'
          src='/assets/background/certificate-bg.jpg'
          sx={{
            width: 1,
            height: 'auto',
            display: { xs: 'none', md: 'block' }
          }}
          />
        
            <Stack sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', position: 'absolute', width: '100%', height: '100%', top: 0, left: 0}}>
              <Image
                alt='ttu mau bang'
                src='/logo/logo.svg'
                sx={{
                  width: { xs: 50, md: 70 },
                  height: 'auto',
                  mb: 1
                }}
              />
              <Typography variant="h5" sx={{ fontSize: '1rem'}}>
                Đại Học Tân Tạo
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', color: '#444', mt: 2}}>
                Thông tin
              </Typography>
              <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', md: '2.5rem' }, color: '#FF5630', textTransform: 'uppercase'}}>
                {certificateData?.type === 0 ? "Bằng Cử Nhân": "Bằng Bác Sĩ Y Khoa"}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', color: '#444'}}>
                Của
              </Typography>
              <Typography variant="h4" sx={{ fontSize: { xs: '1.2rem', md: '2rem' }, color: '#04793e', mb: 1, textTransform: 'capitalize'}}>
                {capitalize(certificateData?.student_name)}                    
              </Typography>
              <Stack sx={{ flexDirection: { xs: "column", md: "row"}, gap: { xs: '0px', md: 2 }, textAlign: 'center'  }}>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Mã sinh viên: <span style={{ fontWeight: 'bold' }}>{certificateData?.student_id_card}</span>
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Ngày sinh: <span style={{ fontWeight: 'bold' }}>{certificateData?.student_dob !== null ? dfm(certificateData?.student_dob) : "Đang cập nhật"}</span>
                </Typography>
              </Stack>
              <Stack sx={{ flexDirection: { xs: "column", md: "row"}, gap: { xs: '0px', md: 2 }, textAlign: 'center'  }}>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Ngành: <span style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>{certificateData?.major?.name_vn}</span>
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Loại hình đào tạo: <span style={{ fontWeight: 'bold' }}>Chính quy</span>
                </Typography>
              </Stack>

              {certificateData?.rank > 0 && 
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Xếp loại: <span style={{ fontWeight: 'bold' }}>{rankTexts[certificateData?.rank] || "Đạt tốt nghiệp"}</span>
                </Typography>
              }
              
              <Stack sx={{ flexDirection: { xs: "column", md: "row"}, gap: { xs: '0px', md: 2 }, textAlign: 'center'  }}>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Năm tốt nghiệp: <span style={{ fontWeight: 'bold' }}>{certificateData?.year}</span>
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1rem'}}>
                  Số hiệu: <span style={{ fontWeight: 'bold' }}>{certificateData?.number}</span>
                </Typography>
              </Stack>
              <Typography variant="body2" sx={{ fontSize: '1rem', fontStyle: 'italic', mt: 2, color: "#FFAB00"}}>
                (Văn bằng này được tra cứu tại certificate.ttu.edu.vn)
              </Typography>
            <IconButton  sx={{ position: 'absolute', top: 0, right: 0}} color="error" onClick={handleClose}>
                <Iconify icon="mingcute:close-fill" />
            </IconButton>
        </Stack>
      </DialogContent>
      
      )}
    </Dialog>
  );

}
